webpackJsonp([18],Array(22).concat([
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});


var baseUrl = "https://cgweb.testappbeta.com";
var paypalUrl = "https://www.sandbox.paypal.com/cgi-bin/webscr";
var basePlatform = "Web_Test_AlphaOld";
var stripeId = "pk_test_8XhB5VRcHU3rYIB0Hb1ddatH";
var appVersion = "1.2.0";

if ("production" == "production" && __webpack_require__.i({"NODE_ENV":"production"}).TEST_ENV !== "staging") {
  exports.baseUrl = baseUrl = location.origin;
  exports.paypalUrl = paypalUrl = "https://www.paypal.com/cgi-bin/webscr";
  exports.basePlatform = basePlatform = "Web_Alpha";
  exports.stripeId = stripeId = "pk_live_P6XItCBqrJVBHpr5l7zWduym";
}
console.log("process.env.TEST_ENV:", __webpack_require__.i({"NODE_ENV":"production"}).TEST_ENV);

exports.baseUrl = baseUrl;
exports.paypalUrl = paypalUrl;
exports.basePlatform = basePlatform;
exports.stripeId = stripeId;
exports.appVersion = appVersion;

/***/ }),
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(42);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(72);

var _vuex2 = _interopRequireDefault(_vuex);

var _mutation = __webpack_require__(140);

var _mutation2 = _interopRequireDefault(_mutation);

var _action = __webpack_require__(139);

var _action2 = _interopRequireDefault(_action);

var _vuexPersistedstate = __webpack_require__(273);

var _vuexPersistedstate2 = _interopRequireDefault(_vuexPersistedstate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var persistPaths = ["userInfo", "masterId", "settingData"];

var state = {
  urlData: {
    source_scheme: "",
    platform: "",
    product_kind: "",
    username: "",
    full_name: "",
    image_src: "",
    follow_count: "",
    like_count: "",
    view_count: "",
    comment_count: "",
    user_coin: "",
    userJson: {},
    taskJson: {},
    offer_id: "",
    app_kind: ""
  },
  masterId: "",
  settingData: {},
  postData: {
    button_id: "",
    custom: ""
  },
  userInfo: {},
  userMediaList: [],
  likeTabData: {
    like_url: "",
    like_count: "",
    view_count: "",
    comment_count: "",
    media_type: 1
  },
  service_list: [],
  subs_follow_month: [],
  subs_follow_week: [],
  subs_like_month: [],
  subs_like_week: [],
  vip_list: [],
  schemeUrl: "",
  mediaListTag: {
    more_available: "",
    max_id: ""
  },
  navTitleName: "",
  confirmShow: false,
  historyBackShow: false,
  coinShow: false,
  collectShow: true,
  taskJsonSign: false,
  tabbarShow: false,
  dataUrl: "",
  tabSeleced: "",
  loadingShow: false,
  midLoadingShow: false,
  midLoadingText: "",
  mtStatus: true,
  vipStatus: false,
  toastShow: false,
  toastText: "",
  toastPosition: "",
  navbarShow: true,
  currentUserData: {},

  allPostData: [],
  allPostCate: "All",
  allPostSelectedId: "",
  subs_tab_show: 0,

  web_tabbar_show: false,
  web_navbar_show: false,
  web_navimg_show: true,
  web_account_show: false,
  web_account_history_show: false,
  web_account_data: [],
  web_ios_addHome_show: false,
  web_android_addHome_show: false,
  web_safari_ads_show: false,
  web_android_ads_show: false,
  web_login_show: false,
  web_edit_button_show: true,
  web_another_account_show: true,
  web_history_data: [],
  web_login_detail_show: false,
  web_guide_show: false,
  web_payment_show: false,
  pay_result: {},
  payment_had_show: false,
  web_free_payment_show: false,
  freeListShow: true
};
exports.default = new _vuex2.default.Store({
  state: state,
  mutations: _mutation2.default,
  actions: _action2.default,
  plugins: [(0, _vuexPersistedstate2.default)({
    paths: persistPaths
  })]
});

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOrderReceipt = exports.createOrder = exports.loginByMasterId = exports.getServiceList = exports.getSettingData = exports.postOffer = exports.freeCheck = exports.freeDeliver = exports.insUserInfo = exports.insMedia = exports.payByWebPayPal = exports.payByCard = undefined;

var _regenerator = __webpack_require__(24);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _qs = __webpack_require__(230);

var _qs2 = _interopRequireDefault(_qs);

var _env = __webpack_require__(22);

var _superpay = __webpack_require__(44);

var _servieHelpers = __webpack_require__(108);

var _paypal = __webpack_require__(138);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var payByCard = exports.payByCard = function payByCard(dataJson) {
  if (dataJson.hasOwnProperty("email")) {
    return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/mobile/post_offer", _qs2.default.stringify({
      offer_id: dataJson.offer_id,
      user_info: (0, _stringify2.default)(dataJson.user_info),
      feed_data: (0, _stringify2.default)(dataJson.feed_data),
      offer_platform: dataJson.offer_platform,
      primary_platform: dataJson.primary_platform,
      receipt: (0, _stringify2.default)({
        stripe_token: dataJson.receipt,
        stripe_email: dataJson.email
      }),
      mver: dataJson.hasOwnProperty("mver") ? dataJson.mver : ""
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  } else {
    return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/mobile/post_offer", _qs2.default.stringify({
      offer_id: dataJson.offer_id,
      user_info: (0, _stringify2.default)(dataJson.user_info),
      feed_data: (0, _stringify2.default)(dataJson.feed_data),
      offer_platform: dataJson.offer_platform,
      primary_platform: dataJson.primary_platform,
      receipt: (0, _stringify2.default)({ stripe_token: dataJson.receipt }),
      mver: dataJson.hasOwnProperty("mver") ? dataJson.mver : ""
    }), {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    });
  }
};

var payByWebPayPal = exports.payByWebPayPal = function payByWebPayPal(_ref) {
  var baseUrl = _ref.baseUrl,
      offer = _ref.offer;

  try {
    console.log("payByWebPayPal:", baseUrl + "?" + (0, _paypal.jumpWebPayPalQueryFactory)(offer));
    window.location.href = baseUrl + "?" + (0, _paypal.jumpWebPayPalQueryFactory)(offer);
  } catch (error) {
    return _promise2.default.reject(error);
  }
};

var insMedia = exports.insMedia = function () {
  var _ref2 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(params) {
    var result;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return _servieHelpers.cryptoHttp.get(_env.baseUrl + "/web/v1/i/user/medias", {
              params: params
            });

          case 3:
            result = _context.sent;
            return _context.abrupt("return", result);

          case 7:
            _context.prev = 7;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", _promise2.default.reject(_context.t0));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 7]]);
  }));

  return function insMedia(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var insUserInfo = exports.insUserInfo = function () {
  var _ref3 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(username) {
    var result;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return _servieHelpers.cryptoHttp.get(_env.baseUrl + "/web/v1/i/user/info", {
              params: {
                username: username
              }
            });

          case 3:
            result = _context2.sent;
            return _context2.abrupt("return", result);

          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
            return _context2.abrupt("return", _promise2.default.reject(_context2.t0));

          case 10:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, undefined, [[0, 7]]);
  }));

  return function insUserInfo(_x2) {
    return _ref3.apply(this, arguments);
  };
}();

var freeDeliver = exports.freeDeliver = function () {
  var _ref4 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3(dataJson) {
    var result;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/web/v1/free/deliver", dataJson);

          case 3:
            result = _context3.sent;
            return _context3.abrupt("return", result);

          case 7:
            _context3.prev = 7;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", _promise2.default.reject(_context3.t0));

          case 10:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, undefined, [[0, 7]]);
  }));

  return function freeDeliver(_x3) {
    return _ref4.apply(this, arguments);
  };
}();

var freeCheck = exports.freeCheck = function () {
  var _ref5 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4(master_id, user_id) {
    var result;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/web/v1/free/check", {
              master_id: master_id,
              user_id: user_id,
              platform: _env.basePlatform
            });

          case 3:
            result = _context4.sent;
            return _context4.abrupt("return", result);

          case 7:
            _context4.prev = 7;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", _promise2.default.reject(_context4.t0));

          case 10:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, undefined, [[0, 7]]);
  }));

  return function freeCheck(_x4, _x5) {
    return _ref5.apply(this, arguments);
  };
}();

var postOffer = exports.postOffer = function () {
  var _ref6 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5(postOfferData) {
    var result;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/web/v1/order/iap", postOfferData);

          case 3:
            result = _context5.sent;
            return _context5.abrupt("return", result);

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", _promise2.default.reject(_context5.t0));

          case 10:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, undefined, [[0, 7]]);
  }));

  return function postOffer(_x6) {
    return _ref6.apply(this, arguments);
  };
}();

var getSettingData = exports.getSettingData = function () {
  var _ref7 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee6() {
    var result;
    return _regenerator2.default.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.prev = 0;
            _context6.next = 3;
            return _servieHelpers.cryptoHttp.get(_env.baseUrl + "/web/v1/settings/content", {
              params: {
                platform: _env.basePlatform,
                app_version: _env.appVersion,
                keys: "client_settings,sale,rewards,rate_task,checkin_rewards,follow_offers,golden_follow_offers,like_offers,comment_offers,view_offers,story_offers,special_follow_offers,special_like_offers,auto_subs_follow_offers,auto_subs_like_offers,coin_offers,limited_coin_offers,lucky_coin_offers,half_coin_offers,feed_coin_offers,service_offers,vip_package_offers,casino,pro_extra_percentage,free_followers_for_newbie_enabled"
              }
            });

          case 3:
            result = _context6.sent;
            return _context6.abrupt("return", result);

          case 7:
            _context6.prev = 7;
            _context6.t0 = _context6["catch"](0);
            return _context6.abrupt("return", _promise2.default.reject(_context6.t0));

          case 10:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6, undefined, [[0, 7]]);
  }));

  return function getSettingData() {
    return _ref7.apply(this, arguments);
  };
}();

var getServiceList = exports.getServiceList = function () {
  var _ref8 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee7(master_id) {
    var result;
    return _regenerator2.default.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            _context7.prev = 0;
            _context7.next = 3;
            return _servieHelpers.cryptoHttp.get(_env.baseUrl + "/web/v1/services/list", {
              params: {
                master_id: master_id,
                platform: _env.basePlatform
              }
            });

          case 3:
            result = _context7.sent;
            return _context7.abrupt("return", result);

          case 7:
            _context7.prev = 7;
            _context7.t0 = _context7["catch"](0);
            return _context7.abrupt("return", _promise2.default.reject(_context7.t0));

          case 10:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7, undefined, [[0, 7]]);
  }));

  return function getServiceList(_x7) {
    return _ref8.apply(this, arguments);
  };
}();

var loginByMasterId = exports.loginByMasterId = function () {
  var _ref9 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee8(master_id, user_id) {
    var result;
    return _regenerator2.default.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            _context8.prev = 0;
            _context8.next = 3;
            return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/web/v1/user/login", {
              platform: _env.basePlatform,
              user_info: {
                master_id: master_id,
                user_id: user_id
              },
              app_version: "1.2.0"
            });

          case 3:
            result = _context8.sent;
            return _context8.abrupt("return", result);

          case 7:
            _context8.prev = 7;
            _context8.t0 = _context8["catch"](0);
            return _context8.abrupt("return", _promise2.default.reject(_context8.t0));

          case 10:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8, undefined, [[0, 7]]);
  }));

  return function loginByMasterId(_x8, _x9) {
    return _ref9.apply(this, arguments);
  };
}();

var createOrder = exports.createOrder = function () {
  var _ref10 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee9(creatOrderData) {
    var result;
    return _regenerator2.default.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            _context9.prev = 0;
            _context9.next = 3;
            return _servieHelpers.cryptoHttp.post(_env.baseUrl + "/web/v1/order/create", (0, _superpay.creatOrderFactory)(creatOrderData));

          case 3:
            result = _context9.sent;
            return _context9.abrupt("return", result);

          case 7:
            _context9.prev = 7;
            _context9.t0 = _context9["catch"](0);
            return _context9.abrupt("return", _promise2.default.reject(_context9.t0));

          case 10:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9, undefined, [[0, 7]]);
  }));

  return function createOrder(_x10) {
    return _ref10.apply(this, arguments);
  };
}();

var getOrderReceipt = exports.getOrderReceipt = function () {
  var _ref11 = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee10(transaction_id) {
    var result;
    return _regenerator2.default.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.prev = 0;
            _context10.next = 3;
            return _servieHelpers.cryptoHttp.get(_env.baseUrl + "/web/v1/order/info", {
              params: { transaction_id: transaction_id }
            });

          case 3:
            result = _context10.sent;
            return _context10.abrupt("return", result);

          case 7:
            _context10.prev = 7;
            _context10.t0 = _context10["catch"](0);
            return _context10.abrupt("return", _promise2.default.reject(_context10.t0));

          case 10:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10, undefined, [[0, 7]]);
  }));

  return function getOrderReceipt(_x11) {
    return _ref11.apply(this, arguments);
  };
}();

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.creatOrderFactory = exports.postOfferFactory = exports.resourceFactory = exports.joinSuperPayUrl = exports.jumpToSuperpay = undefined;

var _getIterator2 = __webpack_require__(80);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _map = __webpack_require__(141);

var _map2 = _interopRequireDefault(_map);

var _regenerator = __webpack_require__(24);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__(23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _lodash = __webpack_require__(73);

var _store = __webpack_require__(31);

var _store2 = _interopRequireDefault(_store);

var _env = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var jumpToSuperpay = exports.jumpToSuperpay = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(schemeUrl) {
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;


            window.location = schemeUrl;
            _context.next = 7;
            break;

          case 4:
            _context.prev = 4;
            _context.t0 = _context["catch"](0);
            return _context.abrupt("return", new _promise2.default.reject(_context.t0));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[0, 4]]);
  }));

  return function jumpToSuperpay(_x) {
    return _ref.apply(this, arguments);
  };
}();

var joinSuperPayUrl = exports.joinSuperPayUrl = function joinSuperPayUrl(postOfferData, offer, schemeUrl) {
  var dataMap = new _map2.default();
  var jionUrl = schemeUrl + "?";

  var sp_identifier = (0, _stringify2.default)(postOfferData);
  var price = offer.iap.price;
  var order_finish_url = location.origin + "/paymentResult";
  var order_fail_url = location.origin + "/paymentResult";
  var order_auto_buy = 1;
  var order_style = 2;
  var order_show_try_for_free = 0;
  var order_information = "";
  var order_web_url = location.origin + "?a=1";
  var order_post_url = _env.baseUrl + "/web/v1/order/iap";
  var order_current_url = location.href;

  dataMap.set("sp_identifier", sp_identifier);
  dataMap.set("price", price);
  dataMap.set("order_finish_url", order_finish_url);
  dataMap.set("order_fail_url", order_fail_url);
  dataMap.set("order_auto_buy", order_auto_buy);
  dataMap.set("order_style", order_style);
  dataMap.set("order_show_try_for_free", order_show_try_for_free);
  dataMap.set("order_information", order_information);

  dataMap.set("order_web_url", order_web_url);
  dataMap.set("order_post_url", order_post_url);
  dataMap.set("order_current_url", order_current_url);

  if ((0, _lodash.isSubsOffer)(offer)) {
    var subscription = offer.subscription;

    dataMap.set("period_type", subscription.period_type);
    dataMap.set("period", subscription.period);
  }

  if (offer.hasOwnProperty("is_no_auto_renew") && !offer.is_no_auto_renew) {
    dataMap.set("auto_renewable", 1);
  } else {
    dataMap.set("auto_renewable", 0);
  }

  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator3.default)(dataMap.keys()), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;

      jionUrl += key + "=" + encodeURIComponent(dataMap.get(key)) + "&";
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  console.log("jionUrl:", {
    jionUrl: jionUrl,
    dataMap: dataMap
  });
  return jionUrl;
};

var resourceFactory = exports.resourceFactory = function resourceFactory(offer) {
  var resource = {};
  var kind = offer.kind;
  var state = _store2.default.state;

  var insUserInfo = state.userInfo;
  var insMediaInfo = state.currentUserData;

  resource.full_name = insUserInfo.user.full_name;
  resource.profile_pic_url = insUserInfo.user.profile_pic_url;
  resource.username = insUserInfo.user.username;
  resource.user_id = insUserInfo.user.id;

  if ((kind.includes("like") || kind.includes("view") || kind.includes("comment")) && !(0, _lodash.isSubsOffer)(offer)) {
    resource.media_id = insMediaInfo.itemId;
    resource.media_type = insMediaInfo.mediaType;
    resource.image_thumb = insMediaInfo.imageUrl;
    resource.image_low = insMediaInfo.imageUrl;
    resource.image_high = insMediaInfo.imageUrl;
  }

  return resource;
};

var postOfferFactory = exports.postOfferFactory = function postOfferFactory(offer) {
  var postOfferData = {};
  var state = _store2.default.state;

  var insUserInfo = state.userInfo;
  var masterId = state.masterId;

  postOfferData.target_user_id = insUserInfo.user.id;
  postOfferData.master_id = masterId;
  postOfferData.app_version = "1.2.0";
  postOfferData.offer_id = offer.offer_id;
  postOfferData.platform = _env.basePlatform;
  postOfferData.resource = resourceFactory(offer);


  console.info("postOfferFactory:", postOfferData);
  return postOfferData;
};

var creatOrderFactory = exports.creatOrderFactory = function creatOrderFactory(offer) {
  var postOfferData = {};
  var state = _store2.default.state;

  var insUserInfo = state.userInfo;
  var masterId = state.masterId;

  var user_info = {
    user_id: insUserInfo.user.id,
    master_id: masterId,
    username: insUserInfo.user.username
  };

  postOfferData.target_user_id = insUserInfo.user.id;
  postOfferData.app_version = "1.2.0";
  postOfferData.offer_id = offer.offer_id;
  postOfferData.platform = _env.basePlatform;
  postOfferData.offer_platform = _env.basePlatform;
  postOfferData.primary_platform = _env.basePlatform;
  postOfferData.feed_data = resourceFactory(offer);
  postOfferData.user_info = user_info;

  console.info("creatOrderFactory:", postOfferData);
  return postOfferData;
};

/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_nav_back_arrow@3x.e0dec29.png";

/***/ }),
/* 68 */,
/* 69 */,
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__(42);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(71);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

exports.default = new _vueRouter2.default({
  mode: "history",
  routes: [{
    path: "/",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(14).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(280)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/successPay/:payData",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(16).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(277)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/cardPay",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(7).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(276)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/login",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(13).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(283)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/login/loginConfirm/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(12).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(284)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: "/follow/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(1).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(281)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: "follow"
  }, {
    path: "/like/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(0).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(282)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    name: "like"
  }, {
    name: "posts",
    path: "/like/posts/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(8).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(286)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "subscription",
    path: "/subscription/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(5).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(288)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "subscriptionMonth",
    path: "/subscription/month/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(3).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(289)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "more",
    path: "/more/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(6).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(285)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "setting",
    path: "/more/setting/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(11).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(287)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "settingFaq",
    path: "/more/setting/FAQ/:userName/:userId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(9).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(278)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "payment",
    path: "/payment",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(2).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(291)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "settingFaqDetail",
    path: "/more/setting/FAQ/detail/:userName/:userId/:detailId",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(15).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(279)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    name: "paymentResult",
    path: "/paymentResult",
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__(292)]; (resolve.apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});

/***/ }),
/* 71 */,
/* 72 */,
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.filterSubsArray = exports.paymentReultTranlateData = exports.offerToKindDesc = exports.getConactUrl = exports.isSubsOffer = undefined;

var _getIterator2 = __webpack_require__(80);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

exports.isIos = isIos;
exports.timestampToTime = timestampToTime;
exports.isPostType = isPostType;
exports.creatUUid = creatUUid;

var _store = __webpack_require__(31);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isIosCache = null;
function isIos() {
  if (isIosCache !== null) {
    return isIosCache;
  } else {
    var u = window.navigator.userAgent;
    var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
    isIosCache = isiOS;
    return isiOS;
  }
}

var isSubsOffer = exports.isSubsOffer = function isSubsOffer(offer) {
  try {
    var result = void 0;
    if (offer.kind.indexOf("vip") > -1) {
      return true;
    } else {
      result = offer.hasOwnProperty("subscription");
    }
    return result;
  } catch (error) {
    return false;
  }
};

var getConactUrl = exports.getConactUrl = function getConactUrl() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1;
  var kg = "%20";
  var hc = "%0A";
  var title = "";
  var osName = "";
  var start = "Hi,%0APlease let us know if you have any problem.(here)%0A%0A%0A%0A%0A";
  if (isAndroid) {
    title = "Web Android Instagram 1.0.0";
    osName = "Android";
  } else {
    title = "Web iOS Instagram 1.0.0 ";
    osName = "iOS";
  }
  var body = "Hi," + hc + "Please let us know if you have any problem." + hc + "(here)" + hc + hc + hc + hc + "Paypal" + kg + "Account:" + hc + "App" + kg + "Version: 1.0" + hc + "Username:" + kg + "" + hc + "User" + kg + "Master_ID:" + kg + _store2.default.state.masterId + hc + "User" + kg + "Agent:" + kg + navigator.userAgent;
  return "mailto:support@followersmania.com?subject=" + title + "&body=" + body;
};

var offerToKindDesc = exports.offerToKindDesc = function offerToKindDesc(offer) {
  if (offer) {
    switch (offer.kind) {
      case "follow":
        {
          return "Followers";
          break;
        }
      case "golden_follow":
        {
          return "Golden Followers";
          break;
        }
      case "like":
        {
          return "Likes";
          break;
        }
      case "comment":
        {
          return "Comments";
          break;
        }
      case "view":
        {
          return "Views";
          break;
        }
      case "vip":
        {
          return "VIP";
          break;
        }
      default:
        break;
    }

    if (offer.kind.includes("subs_like")) {
      return "Subs Likes";
    } else if (offer.kind.includes("subs_follow")) {
      return "Subs Followers";
    }
  } else {
    return "";
  }
};

var paymentReultTranlateData = exports.paymentReultTranlateData = function paymentReultTranlateData(result) {
  if (result) {
    var offer = result.offer_data;
    var resource = result.resource;

    var kindDesc = offerToKindDesc(offer);
    var effect = offer.effect;
    var userPicUrl = "";
    if (isSubsOffer(offer) || !isPostType(offer)) {
      userPicUrl = resource && resource.profile_pic_url;
    } else {
      userPicUrl = resource && resource.image_thumb;
    }

    return {
      userPicUrl: userPicUrl,
      kindDesc: kindDesc,
      effect: effect
    };
  } else {
    return null;
  }
};

function timestampToTime(timestamp) {
  if (timestamp === null || timestamp === undefined) {
    return "";
  }
  var date = new Date(timestamp.toString().length === 10 ? timestamp * 1000 : timestamp);
  var addZero = function addZero(number) {
    return number < 10 ? "0" + number : number;
  };
  var Y = date.getFullYear() + "-";
  var M = (date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1) + "-";
  var D = addZero(date.getDate()) + " ";
  var h = addZero(date.getHours()) + ":";
  var m = addZero(date.getMinutes()) + ":";
  var s = addZero(date.getSeconds());
  return Y + M + D + h + m + s;
}

function isPostType(offer) {
  return offer.kind.includes("like") || offer.kind.includes("comment") || offer.kind.includes("view");
}

function creatUUid() {
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function (c) {
    var r = Math.random() * 16 | 0;
    var v = c === "x" ? r : r & 0x3 | 0x8;
    return v.toString(16);
  }).toUpperCase();
}

var filterSubsArray = exports.filterSubsArray = function filterSubsArray(period_type, service_list, subs_arr) {
  var filterArray = subs_arr.filter(function (item) {
    return item.subscription.period_type === period_type;
  }).map(function (item) {
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = (0, _getIterator3.default)(service_list), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var service = _step.value;

        if (service.offer_id && service.offer_id === item.offer_id) {
          return (0, _extends3.default)({}, item, {
            subscribed: false
          });
          break;
        }
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return (0, _extends3.default)({}, item, {
      subscribed: true
    });
  });
  return filterArray;
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/iamge_nav_cancel@3x.ed4b539.png";

/***/ }),
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_gx_coins@3x.ae564c5.png";

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(265),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;!function(n){"use strict";function t(n,t){var r=(65535&n)+(65535&t);return(n>>16)+(t>>16)+(r>>16)<<16|65535&r}function r(n,t){return n<<t|n>>>32-t}function e(n,e,o,u,c,f){return t(r(t(t(e,n),t(u,f)),c),o)}function o(n,t,r,o,u,c,f){return e(t&r|~t&o,n,t,u,c,f)}function u(n,t,r,o,u,c,f){return e(t&o|r&~o,n,t,u,c,f)}function c(n,t,r,o,u,c,f){return e(t^r^o,n,t,u,c,f)}function f(n,t,r,o,u,c,f){return e(r^(t|~o),n,t,u,c,f)}function i(n,r){n[r>>5]|=128<<r%32,n[14+(r+64>>>9<<4)]=r;var e,i,a,d,h,l=1732584193,g=-271733879,v=-1732584194,m=271733878;for(e=0;e<n.length;e+=16)i=l,a=g,d=v,h=m,g=f(g=f(g=f(g=f(g=c(g=c(g=c(g=c(g=u(g=u(g=u(g=u(g=o(g=o(g=o(g=o(g,v=o(v,m=o(m,l=o(l,g,v,m,n[e],7,-680876936),g,v,n[e+1],12,-389564586),l,g,n[e+2],17,606105819),m,l,n[e+3],22,-1044525330),v=o(v,m=o(m,l=o(l,g,v,m,n[e+4],7,-176418897),g,v,n[e+5],12,1200080426),l,g,n[e+6],17,-1473231341),m,l,n[e+7],22,-45705983),v=o(v,m=o(m,l=o(l,g,v,m,n[e+8],7,1770035416),g,v,n[e+9],12,-1958414417),l,g,n[e+10],17,-42063),m,l,n[e+11],22,-1990404162),v=o(v,m=o(m,l=o(l,g,v,m,n[e+12],7,1804603682),g,v,n[e+13],12,-40341101),l,g,n[e+14],17,-1502002290),m,l,n[e+15],22,1236535329),v=u(v,m=u(m,l=u(l,g,v,m,n[e+1],5,-165796510),g,v,n[e+6],9,-1069501632),l,g,n[e+11],14,643717713),m,l,n[e],20,-373897302),v=u(v,m=u(m,l=u(l,g,v,m,n[e+5],5,-701558691),g,v,n[e+10],9,38016083),l,g,n[e+15],14,-660478335),m,l,n[e+4],20,-405537848),v=u(v,m=u(m,l=u(l,g,v,m,n[e+9],5,568446438),g,v,n[e+14],9,-1019803690),l,g,n[e+3],14,-187363961),m,l,n[e+8],20,1163531501),v=u(v,m=u(m,l=u(l,g,v,m,n[e+13],5,-1444681467),g,v,n[e+2],9,-51403784),l,g,n[e+7],14,1735328473),m,l,n[e+12],20,-1926607734),v=c(v,m=c(m,l=c(l,g,v,m,n[e+5],4,-378558),g,v,n[e+8],11,-2022574463),l,g,n[e+11],16,1839030562),m,l,n[e+14],23,-35309556),v=c(v,m=c(m,l=c(l,g,v,m,n[e+1],4,-1530992060),g,v,n[e+4],11,1272893353),l,g,n[e+7],16,-155497632),m,l,n[e+10],23,-1094730640),v=c(v,m=c(m,l=c(l,g,v,m,n[e+13],4,681279174),g,v,n[e],11,-358537222),l,g,n[e+3],16,-722521979),m,l,n[e+6],23,76029189),v=c(v,m=c(m,l=c(l,g,v,m,n[e+9],4,-640364487),g,v,n[e+12],11,-421815835),l,g,n[e+15],16,530742520),m,l,n[e+2],23,-995338651),v=f(v,m=f(m,l=f(l,g,v,m,n[e],6,-198630844),g,v,n[e+7],10,1126891415),l,g,n[e+14],15,-1416354905),m,l,n[e+5],21,-57434055),v=f(v,m=f(m,l=f(l,g,v,m,n[e+12],6,1700485571),g,v,n[e+3],10,-1894986606),l,g,n[e+10],15,-1051523),m,l,n[e+1],21,-2054922799),v=f(v,m=f(m,l=f(l,g,v,m,n[e+8],6,1873313359),g,v,n[e+15],10,-30611744),l,g,n[e+6],15,-1560198380),m,l,n[e+13],21,1309151649),v=f(v,m=f(m,l=f(l,g,v,m,n[e+4],6,-145523070),g,v,n[e+11],10,-1120210379),l,g,n[e+2],15,718787259),m,l,n[e+9],21,-343485551),l=t(l,i),g=t(g,a),v=t(v,d),m=t(m,h);return[l,g,v,m]}function a(n){var t,r="",e=32*n.length;for(t=0;t<e;t+=8)r+=String.fromCharCode(n[t>>5]>>>t%32&255);return r}function d(n){var t,r=[];for(r[(n.length>>2)-1]=void 0,t=0;t<r.length;t+=1)r[t]=0;var e=8*n.length;for(t=0;t<e;t+=8)r[t>>5]|=(255&n.charCodeAt(t/8))<<t%32;return r}function h(n){return a(i(d(n),8*n.length))}function l(n,t){var r,e,o=d(n),u=[],c=[];for(u[15]=c[15]=void 0,o.length>16&&(o=i(o,8*n.length)),r=0;r<16;r+=1)u[r]=909522486^o[r],c[r]=1549556828^o[r];return e=i(u.concat(d(t)),512+8*t.length),a(i(c.concat(e),640))}function g(n){var t,r,e="";for(r=0;r<n.length;r+=1)t=n.charCodeAt(r),e+="0123456789abcdef".charAt(t>>>4&15)+"0123456789abcdef".charAt(15&t);return e}function v(n){return unescape(encodeURIComponent(n))}function m(n){return h(v(n))}function p(n){return g(m(n))}function s(n,t){return l(v(n),v(t))}function C(n,t){return g(s(n,t))}function A(n,t,r){return t?r?s(t,n):C(t,n):r?m(n):p(n)} true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return A}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof module&&module.exports?module.exports=A:n.md5=A}(this);
//# sourceMappingURL=md5.min.js.map

/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/getz_push_close.7cb921b.png";

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_instagram_placeholder@3x.b394c71.png";

/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canShowPayment = exports.findFeature = exports.isBigPirce = exports.getPayWayTimes = exports.recordPayWayTimes = exports.getEnterTimes = exports.recordEnterTimes = exports.getFirstEnterTimeStamp = exports.recordFirstEnterTimeStamp = undefined;

var _store = __webpack_require__(31);

var _store2 = _interopRequireDefault(_store);

var _localstorage = __webpack_require__(109);

var _localstorage2 = _interopRequireDefault(_localstorage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FIRST_ENTER_TIME_STAMP = "firstEnterTimeStamp";
var ENTER_TIMES = "enterTimes";
var PAY_WAY_TIMES = "payWayTimes";
var HAS_ENTERED = "hasEntered";
var recordFirstEnterTimeStamp = exports.recordFirstEnterTimeStamp = function recordFirstEnterTimeStamp() {
  if (!_localstorage2.default.has(FIRST_ENTER_TIME_STAMP)) {
    _localstorage2.default.set(FIRST_ENTER_TIME_STAMP, new Date().valueOf());
  }
};

var getFirstEnterTimeStamp = exports.getFirstEnterTimeStamp = function getFirstEnterTimeStamp() {
  return parseInt(_localstorage2.default.get(FIRST_ENTER_TIME_STAMP));
};

var recordEnterTimes = exports.recordEnterTimes = function recordEnterTimes() {
  if (!_localstorage2.default.has(ENTER_TIMES)) {
    _localstorage2.default.set(ENTER_TIMES, 1);
    _localstorage2.default.set(HAS_ENTERED, "entered", true);
  } else {
    if (!_localstorage2.default.has(HAS_ENTERED, true)) {
      var enterTimes = parseInt(_localstorage2.default.get(ENTER_TIMES));
      _localstorage2.default.set(ENTER_TIMES, enterTimes + 1);
      _localstorage2.default.set(HAS_ENTERED, "entered", true);
    }
  }
};
var getEnterTimes = exports.getEnterTimes = function getEnterTimes() {
  return parseInt(_localstorage2.default.get(ENTER_TIMES));
};

var setPayWayTime = function setPayWayTime(type, pay_record) {
  for (var key in pay_record) {
    if (type === key) {
      pay_record[key] += 1;
    }
  }
  _localstorage2.default.set(PAY_WAY_TIMES, pay_record);
};

var recordPayWayTimes = exports.recordPayWayTimes = function recordPayWayTimes(type) {
  if (!_localstorage2.default.has(PAY_WAY_TIMES)) {
    var pay_record = {
      iap: 0,
      paypal: 0,
      cash: 0,
      card: 0
    };
    setPayWayTime(type, pay_record);
  } else {
    var _pay_record = _localstorage2.default.get(PAY_WAY_TIMES);
    setPayWayTime(type, _pay_record);
  }
};

var getPayWayTimes = exports.getPayWayTimes = function getPayWayTimes(type) {
  console.log("LocalStorageWorker:", _localstorage2.default);
  var pay_record = _localstorage2.default.get(PAY_WAY_TIMES);
  if (pay_record) {
    return type ? pay_record[type] : pay_record;
  } else {
    var _pay_record2 = {
      iap: 0,
      paypal: 0,
      cash: 0,
      card: 0
    };
    setPayWayTime(type, _pay_record2);
    return _pay_record2;
  }
};

var isBigPirce = exports.isBigPirce = function isBigPirce(store, price) {
  var settingData = store.state.settingData;
  var brg_prices = settingData && settingData.sale && settingData.sale.big_prices;

  return brg_prices.includes(price);
};

var findFeature = exports.findFeature = function findFeature(store, offer, payWay) {
  var price = offer.iap.price;
  var isBigPirceRes = isBigPirce(store, price);
  var settingData = store.state.settingData;
  var features = settingData && settingData.client_settings && settingData.client_settings.features;
  if (payWay === "paypal") {
    var featruesName = isBigPirceRes ? "big_pp_way" : "small_pp_way";
    return features.find(function (ft) {
      return ft.function === featruesName;
    });
  }
};

var canShowPayment = exports.canShowPayment = function canShowPayment(store, offer, payWay) {
  var feature = findFeature(store, offer, payWay);

  var payWayTimes = getPayWayTimes();
  var app_launch_time = getEnterTimes();
  var first_enter_timestamp = getFirstEnterTimeStamp();
  var is_enabled = feature.is_enabled,
      delay = feature.delay,
      event = feature.event;


  var iap_purchase_time = payWayTimes.iap;
  var paypal_purchase_time = payWayTimes.paypal;
  var card_purchase_time = payWayTimes.card;

  var purchase_sum = iap_purchase_time + paypal_purchase_time + card_purchase_time;
  if (!is_enabled) {
    return false;
  }
  var or_open_app = event.find(function (event) {
    return event.eventName === "or_open_app";
  });
  var open_app = event.find(function (event) {
    return event.eventName === "open_app";
  });
  var pay_by_iap = event.find(function (event) {
    return event.eventName === "pay_by_iap";
  });
  var pay_by_cash = event.find(function (event) {
    return event.eventName === "pay_by_cash";
  });
  var delay_action = new Date().getTime() - first_enter_timestamp > delay * 1000;
  var judge_or_open_app = !or_open_app || or_open_app && app_launch_time >= or_open_app.count;
  var judge_open_app = !open_app || open_app && app_launch_time >= open_app.count;
  var judge_pay_by_iap = !pay_by_iap || pay_by_iap && iap_purchase_time >= pay_by_iap.count;
  var judge_pay_by_cash = !pay_by_cash || pay_by_cash && purchase_sum >= pay_by_cash.count;
  return is_enabled && delay_action && (judge_or_open_app || judge_open_app && judge_pay_by_iap && judge_pay_by_cash);
};

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cryptoHttp = exports.resolveGxResult = undefined;

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CryptoJS = __webpack_require__(199);
var key = CryptoJS.enc.Utf8.parse("9vApxLk5G3PAsJrM");
var iv = CryptoJS.enc.Utf8.parse("FnJL7EDzjqWjcaY9");

var resolveGxResult = exports.resolveGxResult = function resolveGxResult(word) {
  var encryptedHexStr = CryptoJS.enc.Hex.parse(word);
  var srcs = CryptoJS.enc.Base64.stringify(encryptedHexStr);
  var decrypt = CryptoJS.AES.decrypt(srcs, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });
  var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
  return decryptedStr.toString();
};

var cryptoHttp = exports.cryptoHttp = _axios2.default.create();

cryptoHttp.interceptors.response.use(function (response) {
  console.info("interceptors response:", response);
  if (response.status === 200) {
    return (0, _extends3.default)({}, response, {
      data: JSON.parse(resolveGxResult(response.data))
    });
  }
  return response;
}, function (error) {
  return _promise2.default.reject(error);
});

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocalStorageWorker = undefined;

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(82);

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = __webpack_require__(145);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(146);

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LocalStorageWorker = exports.LocalStorageWorker = function () {
  function LocalStorageWorker() {
    (0, _classCallCheck3.default)(this, LocalStorageWorker);

    this.localStorageSupported = this.canWriteStorage();

    this.key = {
      COOKIE: "cookie",
      UUID: "uuid",
      GX_USER_LIST: "gx_user_list",
      GX_MEDIA_LIST: "gx_media_list",
      IS_LIMITED_COIN_FIRST_SHOW: "is_limited_coin_first_show"
    };
  }

  (0, _createClass3.default)(LocalStorageWorker, [{
    key: "canWriteStorage",
    value: function canWriteStorage() {
      if (!window.localStorage) {
        console.log("window下不存在localStorage");
        return false;
      }
      try {
        window.localStorage.setItem("@@", "test");
        window.localStorage.removeItem("@@");
        return true;
      } catch (e) {
        console.log("window不能使用localStorage");
        return false;
      }
    }
  }, {
    key: "dataToString",
    value: function dataToString(data) {
      if (data !== undefined && data != null) {
        var type = typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data);
        if (type === "function") {
          return undefined;
        } else if (type === "object") {
          return (0, _stringify2.default)(data);
        } else {
          return data.toString();
        }
      } else {
        return undefined;
      }
    }
  }, {
    key: "stringToData",
    value: function stringToData(str) {
      try {
        return JSON.parse(str);
      } catch (e) {
        return str;
      }
    }
  }, {
    key: "set",
    value: function set(key, data) {
      var isSession = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (this.localStorageSupported) {
        var dataStr = this.dataToString(data);
        !isSession ? localStorage.setItem(key, dataStr) : sessionStorage.setItem(key, dataStr);
        return this.get(key);
      } else {
        return null;
      }
    }
  }, {
    key: "get",
    value: function get(key) {
      var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.localStorageSupported) {
        var data = !isSession ? localStorage.getItem(key) : sessionStorage.getItem(key);
        return this.stringToData(data);
      } else {
        return null;
      }
    }
  }, {
    key: "has",
    value: function has(key) {
      var isSession = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.localStorageSupported) {
        var result = this.get(key, isSession);
        return result == null || result === undefined ? false : true;
      } else {
        return false;
      }
    }
  }, {
    key: "getAll",
    value: function getAll() {
      var result = {};

      return result;
    }
  }, {
    key: "remove",
    value: function remove(key) {
      if (this.localStorageSupported) {
        localStorage.removeItem(key);
      } else {
        return null;
      }
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.localStorageSupported) {
        localStorage.clear();
      } else {
        return null;
      }
    }
  }]);
  return LocalStorageWorker;
}();

var localStorageHelper = new LocalStorageWorker();
exports.default = localStorageHelper;

/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/getz_searchfriendsbox_close.92220d4.png";

/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_faq_detail@3x.a8f5228.png";

/***/ }),
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _TopBar = __webpack_require__(262);

var _TopBar2 = _interopRequireDefault(_TopBar);

var _LoadingMiddle = __webpack_require__(258);

var _LoadingMiddle2 = _interopRequireDefault(_LoadingMiddle);

var _Toast = __webpack_require__(261);

var _Toast2 = _interopRequireDefault(_Toast);

var _WebNavBar = __webpack_require__(263);

var _WebNavBar2 = _interopRequireDefault(_WebNavBar);

var _LoginDetail = __webpack_require__(260);

var _LoginDetail2 = _interopRequireDefault(_LoginDetail);

var _AddToHome = __webpack_require__(257);

var _AddToHome2 = _interopRequireDefault(_AddToHome);

var _Login = __webpack_require__(259);

var _Login2 = _interopRequireDefault(_Login);

var _env = __webpack_require__(22);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: "app",
  data: function data() {
    return {
      paypalUrl: _env.paypalUrl
    };
  },

  computed: {
    urlData: function urlData() {
      return this.$store.state.urlData;
    },
    getType: function getType() {
      return this.$store.state.getType;
    },
    routerLink: function routerLink() {
      return this.$store.state.dataUrl;
    },
    WebrouterLink: function WebrouterLink() {
      return this.$route.params.userName + "/" + this.$route.params.userId;
    },
    tabSeleced: function tabSeleced() {
      return this.$store.state.tabSeleced;
    },
    loadingShow: function loadingShow() {
      return this.$store.state.loadingShow;
    },
    midLoadingShow: function midLoadingShow() {
      return this.$store.state.midLoadingShow;
    },
    postData: function postData() {
      return this.$store.state.postData;
    },
    navName: function navName() {
      return this.$store.state.navTitleName;
    },
    tabbarShow: function tabbarShow() {
      return this.$store.state.tabbarShow;
    },
    coinShow: function coinShow() {
      return this.$store.state.coinShow;
    },
    collectShow: function collectShow() {
      return this.$store.state.collectShow;
    },
    toastShow: function toastShow() {
      return this.$store.state.toastShow;
    },
    toastText: function toastText() {
      return this.$store.state.toastText;
    },
    webTabbarShow: function webTabbarShow() {
      return this.$store.state.web_tabbar_show;
    },
    midLoadingText: function midLoadingText() {
      return this.$store.state.midLoadingText;
    },
    navbarShow: function navbarShow() {
      return this.$store.state.navbarShow;
    },
    web_navbar_show: function web_navbar_show() {
      return this.$store.state.web_navbar_show;
    },
    navImgShow: function navImgShow() {
      return this.$store.state.web_navimg_show;
    },
    webNavImg: function webNavImg() {
      if ((0, _stringify2.default)(this.$store.state.userInfo) == "{}") {
        return "";
      } else {
        return this.$store.state.userInfo.user.profile_pic_url;
      }
    },
    accountShow: function accountShow() {
      return this.$store.state.web_account_show;
    },
    iosAdsShow: function iosAdsShow() {
      return this.$store.state.web_safari_ads_show;
    },
    androidAdsShow: function androidAdsShow() {
      return this.$store.state.web_android_ads_show;
    }
  },
  components: {
    TopBar: _TopBar2.default,
    LoadingMid: _LoadingMiddle2.default,
    Toast: _Toast2.default,
    Ads: function Ads() {
      return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, 290));
    },
    WebTopBar: _WebNavBar2.default,

    AddToHome: _AddToHome2.default,
    Login: _Login2.default,
    LoginDetail: _LoginDetail2.default
  },
  mounted: function mounted() {
    document.getElementById("start-loading").style.cssText = "display:none";
    if (navigator.userAgent.match(/Android/i)) {

      var body = document.getElementsByTagName("body")[0];
      body.setAttribute("class", "android-8");
    }
  },

  methods: {
    followClick: function followClick() {
      this.$router.push({
        name: "follow",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/follow.html");
      ga("send", "pageview");
    },
    likeClick: function likeClick() {
      this.$router.push({
        name: "like",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/like.html");
      ga("send", "pageview");
    },
    subscriptionClick: function subscriptionClick() {
      this.$router.push({
        name: "subscription",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/subscriptions.html");
      ga("send", "pageview");
    },
    moreClick: function moreClick() {
      this.$router.push({
        name: "more",
        params: {
          userName: this.$route.params.userName,
          userId: this.$route.params.userId
        }
      });

      ga("set", "page", "/more.html");
      ga("send", "pageview");
    }
  }
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    loadingShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},
  data: function data() {
    return {};
  },

  methods: {
    hideAddHome: function hideAddHome() {
      this.$store.commit("updateAddHomeShow", {
        "addHome": false
      });
    }
  },
  watch: {},
  computed: {
    iosAddShow: function iosAddShow() {
      return this.$store.state.web_ios_addHome_show;
    },
    androidAddShow: function androidAddShow() {
      return this.$store.state.web_android_addHome_show;
    }
  },
  mounted: function mounted() {
    console.log(this.$store.state.web_ios_addHome_show);
  }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    loadingShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},
  data: function data() {
    return {};
  },

  methods: {},
  watch: {}
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {},
  mounted: function mounted() {},

  computed: {
    userInfoMsg: function userInfoMsg() {
      return this.$store.state.userInfo;
    },
    settingData: function settingData() {
      return this.$store.state.settingData;
    },
    changing: function changing() {
      if (this.searchInput.split("").length > 0) {
        return true;
      } else {
        return false;
      }
    },
    LoginShow: function LoginShow() {
      return this.$store.state.web_login_show;
    },
    clearShow: function clearShow() {
      if (this.searchInput.split("").length > 0) {
        return true;
      } else {
        return false;
      }
    }
  },
  data: function data() {
    return {
      historyShow: false,
      searchInput: "",
      confirmOnoff: false,
      toastShow: false,
      historyData: [],
      historyBgShow: false,
      keydownLoading: false,
      bottomLogo: true
    };
  },

  methods: {
    hideLogo: function hideLogo() {
      this.bottomLogo = false;
    },
    showLogo: function showLogo() {
      var _this = this;

      setTimeout(function () {
        _this.bottomLogo = true;
      }, 1200);
    },
    detailShow: function detailShow() {
      this.$store.commit("updateLoginDetailShow", {
        web_login_detail_show: true
      });
    },
    closeLogin: function closeLogin() {
      this.$store.commit("updateLoginShow", {
        web_login_show: false
      });
    },
    clickHis: function clickHis() {
      this.historyShow = !this.historyShow;
      if (this.getUserslocalStorage() != null) {
        var arr = this.getUserslocalStorage();
        if (arr.length == 0) {
          this.historyBgShow = true;
        }
        this.historyData = this.getUserslocalStorage();
      } else {
        this.historyBgShow = true;
      }
    },
    keyEnterFun: function keyEnterFun() {
      this.clickConfirm();
      return;
    },
    onFocus: function onFocus() {},
    onKeyUp: function onKeyUp() {
      this.searchInput = this.searchInput.replace(/(^\s*)|(\s*$)/g, "");
    },
    emptyInput: function emptyInput() {
      this.searchInput = "";
    },
    clickConfirm: function clickConfirm() {
      ga("send", {
        hitType: "event",
        eventCategory: "search_user_by_click",
        eventAction: "click"
      });

      this.$store.dispatch("updateMidLoadingShow", {
        midLoadingShow: true,
        midLoadingText: ""
      });
      if (this.searchInput != "" && this.confirmOnoff == false) {
        this.confirmOnoff = true;
        var that = this;
        this.updateUsersInfoByUserName(this.searchInput, function () {
          if (that.userInfoMsg.hasOwnProperty("err")) {
            that.confirmOnoff = false;
            return;
          }
          that.$store.commit("updateLoginShow", {
            web_login_show: false
          });
          that.$router.push({
            path: "/follow/" + that.userInfoMsg.user.username + "/" + that.userInfoMsg.user.id
          });
          if ((0, _stringify2.default)(that.$store.state.userInfo) != "{}") {
            var obj = {
              userName: that.$store.state.userInfo.user.username,
              userId: that.$store.state.userInfo.user.id,
              userPic: that.$store.state.userInfo.user.profile_pic_url
            };
            if (that.isLocalStorage()) {
              that.setUserslocalStorage(obj);
            }
          }

          location.reload();
        }, function () {
          that.toastShow = !that.toastShow;
          setTimeout(function () {
            that.confirmOnoff = false;
          }, 2500);
        });
      } else if (this.searchInput == "") {
        this.$store.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
      } else {
        return false;
      }
    },
    maskClick: function maskClick() {
      this.historyShow = false;
    },
    historyClick: function historyClick() {
      this.historyShow = !this.historyShow;
      if (this.getUserslocalStorage() != null) {
        var arr = this.getUserslocalStorage();
        if (arr.length == 0) {
          this.historyBgShow = true;
        }
        this.historyData = this.getUserslocalStorage();
      } else {
        this.historyBgShow = true;
      }
    },
    deleteHistory: function deleteHistory(item) {
      if (confirm("Are you sure to clear?")) {
        this.deleteUserslocalStorage(item);

        this.historyData = this.getUserslocalStorage();

        if (this.historyData.length == 0) {
          this.historyBgShow = false;
          this.$route.push({
            path: "/follow/&/&"
          });
          location.reload();
        }
      }
    },
    selectHistory: function selectHistory(item) {
      var username = item.userName;
      var that = this;
      this.$store.dispatch("updateMidLoadingShow", {
        midLoadingShow: true,
        midLoadingText: ""
      });
      this.updateUsersInfoByUserName(username, function () {
        that.$store.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
        that.$router.push({
          path: "/follow/" + username + "/" + item.userId
        });
      }, function () {
        that.toastShow = !that.toastShow;
      });
    }
  }
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  components: {},
  mounted: function mounted() {},

  computed: {
    detailShow: function detailShow() {
      return this.$store.state.web_login_detail_show;
    }
  },
  data: function data() {
    return {
      contentData: {
        "title": "Make sure you aren't using a private profile ",
        "content": "Tap on the username on the top bar."
      }
    };
  },

  methods: {
    goBack: function goBack() {
      this.$store.commit("updateLoginDetailShow", {
        "web_login_detail_show": false
      });
    }
  }
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    text: String,
    toastShow: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},
  data: function data() {
    return {};
  },

  methods: {},
  computed: {
    position: function position() {
      return this.$store.state.toastPosition;
    }
  },
  watch: {}
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    titleName: String,
    navType: String,
    userCoins: String,
    schemeUrl: String,
    userImg: String,
    collectShow: Boolean,
    coinShow: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    getzType: function getzType() {
      if (this.navType == 'getZ') {
        return true;
      }
    },
    getxType: function getxType() {
      if (this.navType == 'getX') {
        return true;
      }
    },
    historyBack: function historyBack() {
      return this.$store.state.historyBackShow;
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
      this.$store.commit("updateAllPostCate", {
        "allPostCate": "All"
      });
    },
    addHome: function addHome() {
      this.$store.commit("updateAddHomeShow", {
        "addHome": true
      });
    }
  }
};

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  props: {
    titleName: String,
    navType: String,
    userCoins: String,
    schemeUrl: String,
    userImg: String,
    collectShow: Boolean,
    coinShow: Boolean,
    ImgShow: Boolean,
    accountShow: Boolean
  },
  data: function data() {
    return {};
  },

  computed: {
    haveUserName: function haveUserName() {
      if (this.$route.params.userName == "&") {
        return false;
      } else {
        return true;
      }
    },
    getzType: function getzType() {
      if (this.navType == "getZ") {
        return true;
      }
    },
    getxType: function getxType() {
      if (this.navType == "getX") {
        return true;
      }
    },
    historyBack: function historyBack() {
      return this.$store.state.historyBackShow;
    },
    userImgShow: function userImgShow() {
      if (this.$route.params.userName == "&") {
        return false;
      } else {
        return true;
      }
    }
  },
  methods: {
    goBack: function goBack() {
      this.$router.go(-1);
      this.$store.commit("updateAllPostCate", {
        allPostCate: "All"
      });
    },
    historyShow: function historyShow() {
      if (this.$route.params.userName == "&") {
        this.$store.commit("updateLoginShow", {
          web_login_show: true
        });
      } else {
        this.$store.commit("updateAccountHistoryShow", {
          web_account_history_show: true
        });
        this.$store.commit("updateAnonterCountShow", {
          web_another_account_show: true
        });
        if (this.getUserslocalStorage() != null) {
          var arr = this.getUserslocalStorage();
          if (arr.length == 0) {} else {
            this.$store.commit("updateHistoryData", {
              web_history_data: this.getUserslocalStorage()
            });
          }
        }

        if (localStorage.getItem("usersData") && JSON.parse(localStorage.getItem("usersData")).length > 0) {
          this.$store.commit("updateEditButtonShow", {
            web_edit_button_show: true
          });
        } else {
          this.$store.commit("updateEditButtonShow", {
            web_edit_button_show: false
          });
        }
      }
    },
    addHome: function addHome() {
      this.$store.commit("updateAddHomeShow", {
        addHome: true
      });
      ga("send", {
        hitType: "event",
        eventCategory: "add_home_click",
        eventAction: "click"
      });
    }
  }
};

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.store = undefined;

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _regenerator = __webpack_require__(24);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(33);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _vue = __webpack_require__(42);

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__(71);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _App = __webpack_require__(103);

var _App2 = _interopRequireDefault(_App);

var _index = __webpack_require__(70);

var _index2 = _interopRequireDefault(_index);

var _vuex = __webpack_require__(72);

var _vuex2 = _interopRequireDefault(_vuex);

var _store = __webpack_require__(31);

var _store2 = _interopRequireDefault(_store);

var _axios = __webpack_require__(69);

var _axios2 = _interopRequireDefault(_axios);

var _env = __webpack_require__(22);

var _md5Min = __webpack_require__(104);

var _md5Min2 = _interopRequireDefault(_md5Min);

var _service = __webpack_require__(32);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);
_vue2.default.use(_vueRouter2.default);

new _vue2.default({
  el: "#app",
  router: _index2.default,
  store: _store2.default,
  template: "<App/>",
  components: {
    App: _App2.default
  },
  created: function created() {
    _store2.default.dispatch("initApp");
  }
});

window.confirm = function (message) {
  var iframe = document.createElement("IFRAME");
  iframe.style.display = "none";
  iframe.setAttribute("src", "data:text/plain,");
  document.documentElement.appendChild(iframe);
  var alertFrame = window.frames[0];
  var result = alertFrame.window.confirm(message);
  iframe.parentNode.removeChild(iframe);
  return result;
};

_index2.default.beforeEach(function (to, from, next) {
  console.info("beforeEach:", {
    to: to,
    from: from,
    next: next
  });

  _store2.default.dispatch("updateMidLoadingShow", {
    midLoadingShow: true,
    midLoadingText: ""
  });
  _store2.default.dispatch("updateCoinShow", {
    coinShow: false
  });
  _store2.default.dispatch("updateCollectShow", {
    collectShow: true
  });

  var TO_PATH_ARR = to.path.split("/");
  var TO_PATH = TO_PATH_ARR[TO_PATH_ARR.length - 1];

  switch (TO_PATH) {
    case "follow":
      _store2.default.dispatch("updateTabSeleced", {
        tabSeleced: "follow"
      });
      break;
    case "like":
      _store2.default.dispatch("updateTabSeleced", {
        tabSeleced: "like"
      });
      break;
    case "coin":
      _store2.default.dispatch("updateTabSeleced", {
        tabSeleced: "coin"
      });
      break;
    case "view":
      _store2.default.dispatch("updateTabSeleced", {
        tabSeleced: "view"
      });
      break;
    default:
  }

  next();
});

_index2.default.afterEach(function (route) {
  window.scrollTo(0, 0);
});


function isLocalStorageMain() {
  var Key = "test",
      storage_main = window.localStorage;
  try {
    storage_main.setItem(Key, "testValue");
    storage_main.removeItem(Key);
    console.log("can localStorage");
    return true;
  } catch (error) {
    console.log("no localStorage");
    return false;
  }
}

_vue2.default.prototype.$http = _axios2.default;

_vue2.default.prototype.isLocalStorage = function () {
  var testKey = "test",
      storage = window.localStorage;
  try {
    storage.setItem(testKey, "testValue");
    storage.removeItem(testKey);
    console.log("can localStorage");
    return true;
  } catch (error) {
    console.log("no localStorage");
    return false;
  }
};

_vue2.default.prototype.encryption = function (str) {
  var result = (0, _md5Min2.default)(str);
  return result;
};

var resolveUserInfo = function resolveUserInfo(stringData) {
  return new _promise2.default(function (resolve, reject) {
    try {
      if (stringData == "") {
        reject("empty string");
      } else {
        resolve(stringData.graphql);
      }
    } catch (error) {
      reject(error);
    }
  });
};

_vue2.default.prototype.updateUsersInfoByUserName = function (userName, successCallBack, falseCallBack, loadingOnOff) {
  var _arguments = arguments;

  if (userName === "&" || !userName) {
    falseCallBack();
  } else {
    var that = this;

    (0, _service.insUserInfo)(userName).then(function (response) {
      console.log("解析到的字符串:", response);
      resolveUserInfo(response.data).then(function (data) {
        console.log("resolveUserInfo", data);
        that.$store.commit("updateUserInfo", {
          userInfo: data
        });
        if (successCallBack) {
          successCallBack();
        }
        _store2.default.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
      }).catch(function (error) {
        _store2.default.dispatch("updateMidLoadingShow", {
          midLoadingShow: false,
          midLoadingText: ""
        });
      });
    }, function (response) {
      ga("send", {
        hitType: "event",
        eventCategory: "Get_user_info failed",
        eventAction: "net_err"
      });

      console.log("失败:" + response);
      if (falseCallBack) {
        falseCallBack();
      }
      _store2.default.dispatch("updateMidLoadingShow", {
        midLoadingShow: false,
        midLoadingText: ""
      });
      console.info(_arguments);
      if (loadingOnOff) {
        console.log("keyenter");
        _store2.default.dispatch("updateToastShow", {
          toastShow: true,
          toastText: "No people found, please check your username.",
          position: "top"
        });
      } else {
        console.log("clickenter");
        _store2.default.dispatch("updateToastShow", {
          toastShow: true,
          toastText: "No people found, please check your username."
        });
      }
    });
  }
};

_vue2.default.prototype.updateUsersMediaListById = function (morePage, successCallBack, falseCallBack) {
  if (this.$route.params.userName == "&") {} else {
    var getData = function getData(data) {
      var userId = "";
      var userName = "";
      if (that.$store.state.urlData.username == "") {
        userId = that.$route.params.userId;
        userName = that.$route.params.userName;
      } else {
        userId = JSON.parse(that.$store.state.urlData.userJson).user_id;
        userName = that.$store.state.urlData.username;
      }
      var params = {
        username: userName,
        user_id: userId
      };
      if (MaxId !== "") {
        params.max_id = MaxId;
      }
      (0, _service.insMedia)(params).then(function (response) {
        console.log(response.data);

        if (response.data.items.length == 0) {
          if (successCallBack) {
            successCallBack();
          }
          return;
        }

        that.$store.commit("updateUserMediaList", {
          userMediaList: response.data.items
        });

        that.$store.commit("updateMediaListTag", {
          mediaListTag: {
            more_available: response.data.more_available,
            max_id: response.data.next_cursor
          }
        });
        if (successCallBack) {
          successCallBack();
        }
        console.info(that.$store.state.mediaListTag);
      }, function (response) {

        ga("send", {
          hitType: "event",
          eventCategory: "Get_user_media_data failed",
          eventAction: "net_err"
        });

        console.log("获取userMedia失败:" + response);
        if (falseCallBack) {
          falseCallBack();
        }
        _store2.default.dispatch("updateToastShow", {
          toastShow: true,
          toastText: "Get userMedia failed."
        });
      });
    };

    var MaxId = "";
    if (morePage) {
      if (!this.$store.state.mediaListTag.more_available) {

        if (successCallBack) {
          successCallBack();
        }
        return false;
      } else {
        MaxId = this.$store.state.mediaListTag.max_id;
      }
    } else {}

    var that = this;


    getData();
  }
};

_vue2.default.prototype.postFreeData = function () {
  var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee(dataJson, successCallBack, errorCallBack) {
    var user_id, masterId, freeCheckResult, deliverRestul;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            console.log(isLocalStorageMain());
            _store2.default.dispatch("updateMidLoadingShow", {
              midLoadingShow: true,
              midLoadingText: "Loading order"
            });
            console.log("dataJson:", dataJson);

            user_id = dataJson.user_id;
            masterId = _store2.default.state.masterId;
            _context.prev = 5;
            _context.next = 8;
            return (0, _service.freeCheck)(masterId, user_id);

          case 8:
            freeCheckResult = _context.sent;

            console.log("freeCheckResult:", freeCheckResult);

            if (!(freeCheckResult.data && freeCheckResult.data.data && freeCheckResult.data.data.free_status === 1)) {
              _context.next = 14;
              break;
            }

            console.log("经过校验");
            _context.next = 19;
            break;

          case 14:
            errorCallBack();
            _store2.default.dispatch("updateToastShow", {
              toastShow: true,
              toastText: "You have got free followers."
            });
            _store2.default.dispatch("updateMidLoadingShow", {
              midLoadingShow: false,
              midLoadingText: ""
            });
            if (isLocalStorageMain()) {
              localStorage.setItem("freeFollow", "true");
            }
            return _context.abrupt("return");

          case 19:
            _context.next = 21;
            return (0, _service.freeDeliver)((0, _extends3.default)({}, dataJson, {
              platform: _env.basePlatform
            }));

          case 21:
            deliverRestul = _context.sent;

            console.log(deliverRestul.data);
            _store2.default.dispatch("updateMidLoadingShow", {
              midLoadingShow: false,
              midLoadingText: ""
            });
            if (deliverRestul.data.data && deliverRestul.data.data.expected) {
              if (isLocalStorageMain()) {
                localStorage.setItem("freeFollow", "true");
              }
              if (successCallBack) {
                successCallBack();
              }
            } else {
              _store2.default.dispatch("updateToastShow", {
                toastShow: true,
                toastText: "Get free followers failed."
              });

              if (isLocalStorageMain()) {
                localStorage.setItem("freeFollow", "true");
              }
            }
            _context.next = 33;
            break;

          case 27:
            _context.prev = 27;
            _context.t0 = _context["catch"](5);

            console.log("postFreeData error:", _context.t0);
            ga("send", {
              hitType: "event",
              eventCategory: "Post_free_follow_data failed",
              eventAction: "net_err"
            });

            _store2.default.dispatch("updateMidLoadingShow", {
              midLoadingShow: false,
              midLoadingText: ""
            });
            _store2.default.dispatch("updateToastShow", {
              toastShow: true,
              toastText: "Connect failed"
            });

          case 33:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, undefined, [[5, 27]]);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}();

_vue2.default.prototype.setUrlDataLocalStorage = function () {
  var dataJson = {
    data: _store2.default.state.urlData,
    url: _store2.default.state.dataUrl,
    full_url: window.location.href
  };


  var data = (0, _stringify2.default)(dataJson);

  localStorage.setItem("urlData", data);
  var finalData = localStorage.getItem("urlData");
  console.info(JSON.parse(finalData));
};

_vue2.default.prototype.getUrlDataLocalStorage = function () {
  var data = localStorage.getItem("urlData");
  return JSON.parse(data);
};

_vue2.default.prototype.getUserslocalStorage = function () {
  var usersData = localStorage.getItem("usersData");
  if (usersData) {
    var newObj = JSON.parse(usersData);
    return newObj;
  } else if (usersData == null || userData.length == 0) {
    return null;
  }
};

_vue2.default.prototype.setUserslocalStorage = function (obj) {
  var usersData = localStorage.getItem("usersData");
  var Arr = JSON.parse(usersData);
  if (Arr == null || Arr.length == 0) {
    var arr = [];
    arr.unshift(obj);
    var newArr = (0, _stringify2.default)(arr);
    console.log(newArr);
    localStorage.setItem("usersData", newArr);
  } else {
    if (this.contains(Arr, obj)) {} else {
      Arr.unshift(obj);
      var newArr = (0, _stringify2.default)(Arr);
      localStorage.setItem("usersData", newArr);
    }
  }
  console.info(localStorage.getItem("usersData"));
};

_vue2.default.prototype.contains = function (Arr, obj) {
  for (var i in Arr) {
    if ((0, _stringify2.default)(Arr[i]) == (0, _stringify2.default)(obj)) {
      return true;
    }
  }
  return false;
};

_vue2.default.prototype.deleteUserslocalStorage = function (obj) {
  var usersData = localStorage.getItem("usersData");

  if (usersData) {
    var arr = JSON.parse(usersData);
    var newArr = [];
    for (var i in arr) {
      if ((0, _stringify2.default)(arr[i]) === (0, _stringify2.default)(obj)) {} else {
        newArr.push(arr[i]);
      }
    }
    var finalArr = (0, _stringify2.default)(newArr);

    localStorage.setItem("usersData", finalArr);
  } else {
    return false;
  }
};

_vue2.default.prototype.getIdByIndex = function (index) {
  return this.$store.state.userMediaList[index].id;
};

_vue2.default.prototype.getIndexById = function (Id) {
  for (var i in this.$store.state.userMediaList) {
    if (this.$store.state.userMediaList[i].id == Id) {
      return i;
    }
  }
};

exports.store = _store2.default;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.jumpWebPayPalQueryFactory = exports.objectToString = undefined;

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _typeof2 = __webpack_require__(82);

var _typeof3 = _interopRequireDefault(_typeof2);

var _superpay = __webpack_require__(44);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapKey = {
  uc: "user_coin",
  is: "image_src",
  ss: "source_scheme",
  fn: "full_name",
  av: "mver",
  pf: "platform",
  pk: "product_kind",
  ak: "appKind",
  un: "username",
  fc: "follow_count",
  lc: "like_count",
  vc: "view_count",
  cc: "comment_count",
  uj: "user_info",
  tj: "feed_data",
  oi: "offer_id",
  ru: "redirect_url"
};

var objectToString = exports.objectToString = function objectToString(data) {
  if ((typeof data === "undefined" ? "undefined" : (0, _typeof3.default)(data)) === "object") {
    return (0, _stringify2.default)(data);
  } else if (typeof data === "string") {
    return data;
  } else {
    return data.toString();
  }
};

var jumpWebPayPalQueryFactory = exports.jumpWebPayPalQueryFactory = function jumpWebPayPalQueryFactory(offer) {
  var postOfferData = (0, _superpay.creatOrderFactory)(offer);
  var newArray = [];

  for (var key in postOfferData) {
    for (var map in mapKey) {
      if (mapKey[map] === key) {
        newArray.push(map + "=" + encodeURIComponent(objectToString(postOfferData[key])));
      }
    }
  }

  newArray.push("ru=" + window.location.origin + "/paymentResult?paypal_result=");

  console.log("newArray:", newArray);

  return newArray.join("&");
};

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(147);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(14);

var _promise2 = _interopRequireDefault(_promise);

var _regenerator = __webpack_require__(24);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__(23);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _updateImageSrc$updat;

var _index = __webpack_require__(70);

var _index2 = _interopRequireDefault(_index);

var _superpay = __webpack_require__(44);

var _lodash = __webpack_require__(73);

var _service = __webpack_require__(32);

var _service2 = __webpack_require__(32);

var _payment = __webpack_require__(107);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_updateImageSrc$updat = {
  updateImageSrc: function updateImageSrc(_ref, payload) {
    var commit = _ref.commit,
        state = _ref.state;

    commit("updateImageSrc", payload.image_src);
  },
  updateScheme: function updateScheme(_ref2, payload) {
    var commit = _ref2.commit,
        state = _ref2.state;

    commit("updateScheme", payload.source_scheme);
  },
  updatePlatform: function updatePlatform(_ref3, payload) {
    var commit = _ref3.commit,
        state = _ref3.state;

    commit("updatePlatform", payload.platform);
  },
  updateUsername: function updateUsername(_ref4, payload) {
    var commit = _ref4.commit,
        state = _ref4.state;

    commit("updateUsername", payload.username);
  },
  updateFullname: function updateFullname(_ref5, payload) {
    var commit = _ref5.commit,
        state = _ref5.state;

    commit("updateFullname", payload.full_name);
  },
  updateFollowCount: function updateFollowCount(_ref6, payload) {
    var commit = _ref6.commit,
        state = _ref6.state;


    commit("updateFollowCount", payload.follow_count);
  },
  updateLikeCount: function updateLikeCount(_ref7, payload) {
    var commit = _ref7.commit,
        state = _ref7.state;


    commit("updateLikeCount", payload.like_count);
  },
  updateViewCount: function updateViewCount(_ref8, payload) {
    var commit = _ref8.commit,
        state = _ref8.state;


    commit("updateViewCount", payload.view_count);
  },
  updateCommentCount: function updateCommentCount(_ref9, payload) {
    var commit = _ref9.commit,
        state = _ref9.state;


    commit("updateCommentCount", payload.comment_count);
  },
  updateLikeTabData: function updateLikeTabData(_ref10, payload) {
    var commit = _ref10.commit,
        state = _ref10.state;


    commit("updateLikeTabData", payload.likeTabData);
  },
  updateProductKind: function updateProductKind(_ref11, payload) {
    var commit = _ref11.commit,
        state = _ref11.state;

    commit("updateProductKind", payload.product_kind);
  },
  updateUserJson: function updateUserJson(_ref12, payload) {
    var commit = _ref12.commit,
        state = _ref12.state;

    commit("updateUserJson", payload.userJson);
  },
  updateUserCoin: function updateUserCoin(_ref13, payload) {
    var commit = _ref13.commit,
        state = _ref13.state;

    commit("updateUserCoin", payload.user_coin);
  },
  updateTaskJson: function updateTaskJson(_ref14, payload) {
    var commit = _ref14.commit,
        state = _ref14.state;

    commit("updateTaskJson", payload.taskJson);
  },
  updateConfirmShow: function updateConfirmShow(_ref15, payload) {
    var commit = _ref15.commit,
        state = _ref15.state;

    commit("updateConfirmShow", payload.confirmShow);
  },
  updateSettingData: function updateSettingData(_ref16, payload) {
    var commit = _ref16.commit,
        state = _ref16.state;

    commit("updateSettingData", payload.settingData);
  },
  updateGetType: function updateGetType(_ref17, payload) {
    var commit = _ref17.commit,
        state = _ref17.state;

    commit("updateGetType", payload.getType);
  },
  updateOfferId: function updateOfferId(_ref18, payload) {
    var commit = _ref18.commit,
        state = _ref18.state;

    commit("updateOfferId", payload.offer_id);
  },
  updateHistoryBackShow: function updateHistoryBackShow(_ref19, payload) {
    var commit = _ref19.commit,
        state = _ref19.state;

    commit("updateHistoryBackShow", payload.historyBack);
  },
  updateCoinShow: function updateCoinShow(_ref20, payload) {
    var commit = _ref20.commit,
        state = _ref20.state;

    commit("updateCoinShow", payload.coinShow);
  },
  updateCollectShow: function updateCollectShow(_ref21, payload) {
    var commit = _ref21.commit,
        state = _ref21.state;

    commit("updateCollectShow", payload.collectShow);
  },
  updateSchemeUrl: function updateSchemeUrl(_ref22, payload) {
    var commit = _ref22.commit,
        state = _ref22.state;

    commit("updateSchemeUrl", payload.schemeUrl);
  },
  updateTaskJsonSign: function updateTaskJsonSign(_ref23, payload) {
    var commit = _ref23.commit,
        state = _ref23.state;

    commit("updateTaskJsonSign", payload.taskJsonSign);
  },
  updateAppKind: function updateAppKind(_ref24, payload) {
    var commit = _ref24.commit,
        state = _ref24.state;

    commit("updateAppKind", payload.appKind);
  },
  updateDataUrl: function updateDataUrl(_ref25, payload) {
    var commit = _ref25.commit,
        state = _ref25.state;

    commit("updateDataUrl", payload.dataUrl);
  },
  updateTabSeleced: function updateTabSeleced(_ref26, payload) {
    var commit = _ref26.commit,
        state = _ref26.state;

    commit("updateTabSeleced", payload.tabSeleced);
  },
  updateLoadingShow: function updateLoadingShow(_ref27, payload) {
    var commit = _ref27.commit,
        state = _ref27.state;

    commit("updateLoadingShow", payload.loadingShow);
  },
  updateMver: function updateMver(_ref28, payload) {
    var commit = _ref28.commit,
        state = _ref28.state;

    commit("updateMver", payload.mver);
  },
  updateMidLoadingShow: function updateMidLoadingShow(_ref29, payload) {
    var commit = _ref29.commit,
        state = _ref29.state;

    commit("updateMidLoadingShow", payload);
  },
  updatePostData: function updatePostData(_ref30, payload) {
    var commit = _ref30.commit,
        state = _ref30.state;

    commit("updatePostData", payload.postData);
  },
  updateNavTitleName: function updateNavTitleName(_ref31, payload) {
    var commit = _ref31.commit,
        state = _ref31.state;

    commit("updateNavTitleName", payload.navTitleName);
  },
  updateTabbarShow: function updateTabbarShow(_ref32, payload) {
    var commit = _ref32.commit,
        state = _ref32.state;

    commit("updateTabbarShow", payload.tabbarShow);
  },
  updateMtStatus: function updateMtStatus(_ref33, payload) {
    var commit = _ref33.commit,
        state = _ref33.state;

    commit("updateMtStatus", payload.mtStatus);
  },
  initApp: function initApp(_ref34, payload) {
    var _this = this;

    var commit = _ref34.commit,
        state = _ref34.state,
        dispatch = _ref34.dispatch;
    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
      return _regenerator2.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              (0, _payment.recordFirstEnterTimeStamp)();

              (0, _payment.recordEnterTimes)();

              dispatch("updateMasterId").catch();

              dispatch("loginByMasterId", {
                masterId: state.masterId,
                userId: state.masterId
              }).catch();
              _context.next = 6;
              return dispatch("updateSettingData").catch();

            case 6:
              dispatch("updateServiceList").catch();

            case 7:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },
  updateServiceList: function updateServiceList(_ref35, payload) {
    var _this2 = this;

    var commit = _ref35.commit,
        state = _ref35.state,
        dispatch = _ref35.dispatch;
    return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
      var response;
      return _regenerator2.default.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return (0, _service.getServiceList)(state.masterId);

            case 3:
              response = _context2.sent;

              commit("upadteServiceList", response.data.data);
              return _context2.abrupt("return", response);

            case 8:
              _context2.prev = 8;
              _context2.t0 = _context2["catch"](0);

              console.log("getServiceList error:", _context2.t0);
              return _context2.abrupt("return", _promise2.default.reject(_context2.t0));

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this2, [[0, 8]]);
    }))();
  }
}, (0, _defineProperty3.default)(_updateImageSrc$updat, "updateSettingData", function updateSettingData(_ref36) {
  var _this3 = this;

  var state = _ref36.state,
      commit = _ref36.commit,
      dispatch = _ref36.dispatch;
  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
    var response;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return (0, _service.getSettingData)();

          case 3:
            response = _context3.sent;

            console.log("response?", response);
            commit("updateSettingData", {
              settingData: response.data.data
            });
            return _context3.abrupt("return", response);

          case 9:
            _context3.prev = 9;
            _context3.t0 = _context3["catch"](0);

            console.log("updateSettingData error:", _context3.t0);
            return _context3.abrupt("return", _promise2.default.reject(_context3.t0));

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, _this3, [[0, 9]]);
  }))();
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "updateToastShow", function updateToastShow(_ref37, payload) {
  var commit = _ref37.commit;

  commit("updateToastShow", payload);
  setTimeout(function () {
    commit("updateToastShow", {
      toastShow: false,
      toastText: "",
      position: ""
    });
  }, 2500);
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "updateMasterId", function updateMasterId(_ref38) {
  var commit = _ref38.commit,
      state = _ref38.state;

  if (state.masterId === "") {
    commit("updateMasterId", (0, _lodash.creatUUid)());
  }
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "loginByMasterId", function loginByMasterId(_ref39, payload) {
  var _this4 = this;

  var state = _ref39.state;
  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
    var masterId, userId, response;
    return _regenerator2.default.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            masterId = payload.masterId, userId = payload.userId;
            _context4.next = 4;
            return (0, _service.loginByMasterId)(masterId, userId);

          case 4:
            response = _context4.sent;

            console.log("loginByMasterId resppose:", response);
            return _context4.abrupt("return", response);

          case 9:
            _context4.prev = 9;
            _context4.t0 = _context4["catch"](0);

            console.log("loginByMasterId erro:", _context4.t0);
            return _context4.abrupt("return", _promise2.default.reject(_context4.t0));

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, _this4, [[0, 9]]);
  }))();
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "payByAny", function payByAny(_ref40, payload) {
  var commit = _ref40.commit;

  _index2.default.push({
    name: "payment",
    query: {
      offer: (0, _stringify2.default)(payload)
    }
  });
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "payBySuperPay", function payBySuperPay(_ref41, payload) {
  var commit = _ref41.commit;
  var offer = payload.offer,
      schemeUrl = payload.schemeUrl;

  var payUrl = (0, _superpay.joinSuperPayUrl)((0, _superpay.postOfferFactory)(offer), offer, schemeUrl);

  (0, _superpay.jumpToSuperpay)(payUrl);
}), (0, _defineProperty3.default)(_updateImageSrc$updat, "payByPayPal", function payByPayPal(_ref42, payload) {
  var _this5 = this;

  var commit = _ref42.commit,
      dispatch = _ref42.dispatch,
      getters = _ref42.getters,
      state = _ref42.state;
  return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee5() {
    var offer, settingData, baseUrl, response;
    return _regenerator2.default.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            offer = payload.offer;
            settingData = state.settingData;
            baseUrl = settingData.client_settings.paypal.web_pay_url;

            (0, _service2.payByWebPayPal)({
              baseUrl: baseUrl,
              offer: offer
            });
            return _context5.abrupt("return");

          case 8:
            response = _context5.sent;

            console.log("payByPayPal result:", response);
            if (response.data.result == "succ") {
              dispatch("updatePostData", {
                postData: {
                  button_id: response.data.button_id,
                  custom: response.data.uuid
                }
              });

              setTimeout(function () {
                document.getElementById("post-form").submit();
              }, 200);
            } else {
              dispatch("updateToastShow", {
                toastShow: true,
                toastText: "Oops,Post data failed,please try again."
              });
            }
            _context5.next = 17;
            break;

          case 13:
            _context5.prev = 13;
            _context5.t0 = _context5["catch"](0);

            dispatch("updateToastShow", {
              toastShow: true,
              toastText: "Oops,Post data failed,please try again."
            });

            return _context5.abrupt("return", _promise2.default.reject(_context5.t0));

          case 17:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, _this5, [[0, 13]]);
  }))();
}), _updateImageSrc$updat);

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__(8);

var _stringify2 = _interopRequireDefault(_stringify);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  updateImageSrc: function updateImageSrc(state, payload) {
    state.urlData.image_src = payload;
  },
  updateScheme: function updateScheme(state, payload) {
    state.urlData.source_scheme = payload;
  },
  updatePlatform: function updatePlatform(state, payload) {
    state.urlData.platform = payload;
  },
  updateUsername: function updateUsername(state, payload) {
    state.urlData.username = payload;
  },
  updateFullname: function updateFullname(state, payload) {
    state.urlData.full_name = payload;
  },
  updateUserCoin: function updateUserCoin(state, payload) {
    state.urlData.user_coin = payload;
  },
  updateMver: function updateMver(state, payload) {
    state.urlData.mver = payload;
  },
  updateFollowCount: function updateFollowCount(state, payload) {
    state.urlData.follow_count = payload;
  },
  updateLikeCount: function updateLikeCount(state, payload) {
    state.urlData.like_count = payload;
  },
  updateViewCount: function updateViewCount(state, payload) {
    state.urlData.view_count = payload;
  },
  updateCommentCount: function updateCommentCount(state, payload) {
    state.urlData.comment_count = payload;
  },
  updateLikeTabData: function updateLikeTabData(state, payload) {
    state.likeTabData = payload;
  },
  updateMediaListTag: function updateMediaListTag(state, payload) {
    state.mediaListTag = payload.mediaListTag;
  },
  updateUserMediaList: function updateUserMediaList(state, payload) {
    for (var i in payload.userMediaList) {
      state.userMediaList.push(payload.userMediaList[i]);
    }
  },
  updateProductKind: function updateProductKind(state, payload) {
    state.urlData.product_kind = payload;
  },
  updateUserJson: function updateUserJson(state, payload) {
    state.urlData.userJson = payload;
  },
  updateTaskJson: function updateTaskJson(state, payload) {
    state.urlData.taskJson = payload;
  },
  updateOfferId: function updateOfferId(state, payload) {
    state.urlData.offer_id = payload;
  },
  updateAppKind: function updateAppKind(state, payload) {
    state.urlData.app_kind = payload;
  },
  updateConfirmShow: function updateConfirmShow(state, payload) {
    state.confirmShow = payload;
  },
  updateSettingData: function updateSettingData(state, payload) {
    state.settingData = payload.settingData;
  },
  updateGetType: function updateGetType(state, payload) {
    state.getType = payload;
  },
  updateHistoryBackShow: function updateHistoryBackShow(state, payload) {
    state.historyBackShow = payload;
  },
  updateCoinShow: function updateCoinShow(state, payload) {
    state.coinShow = payload;
  },
  updateCollectShow: function updateCollectShow(state, payload) {
    state.collectShow = payload;
  },
  updateSchemeUrl: function updateSchemeUrl(state, payload) {
    state.schemeUrl = payload;
  },
  updateTaskJsonSign: function updateTaskJsonSign(state, payload) {
    state.taskJsonSign = payload;
  },
  updateDataUrl: function updateDataUrl(state, payload) {
    state.dataUrl = payload;
  },
  updateTabSeleced: function updateTabSeleced(state, payload) {
    state.tabSeleced = payload;
  },
  updateLoadingShow: function updateLoadingShow(state, payload) {
    state.loadingShow = payload;
  },
  updateGuideShow: function updateGuideShow(state, payload) {
    state.web_guide_show = payload.web_guide_show;
  },
  updateMidLoadingShow: function updateMidLoadingShow(state, payload) {
    state.midLoadingShow = payload.midLoadingShow;
    state.midLoadingText = payload.midLoadingText;
  },
  updatePostData: function updatePostData(state, payload) {
    state.postData = payload;
  },
  updateNavTitleName: function updateNavTitleName(state, payload) {
    state.navTitleName = payload;
  },
  updateUserInfo: function updateUserInfo(state, payload) {
    state.userInfo = payload.userInfo;
  },
  updateTabbarShow: function updateTabbarShow(state, payload) {
    state.tabbarShow = payload;
  },
  updateAllUrlData: function updateAllUrlData(state, payload) {
    state.urlData = payload.urlData;
  },
  updateMtStatus: function updateMtStatus(state, payload) {
    state.mtStatus = payload;
  },
  updateSubsFollowMonth: function updateSubsFollowMonth(state, payload) {
    state.subs_follow_month = payload;
  },
  updateSubsLikeMonth: function updateSubsLikeMonth(state, payload) {
    state.subs_like_month = payload;
  },
  updateSubsFollowWeek: function updateSubsFollowWeek(state, payload) {
    state.subs_follow_week = payload;
  },
  updateSubsLikeWeek: function updateSubsLikeWeek(state, payload) {
    state.subs_like_week = payload;
  },
  updateVipStatus: function updateVipStatus(state, payload) {
    state.vipStatus = payload;
  },
  updateVipList: function updateVipList(state, payload) {
    state.vip_list = payload;
  },
  updateToastShow: function updateToastShow(state, payload) {
    state.toastShow = payload.toastShow;
    if (payload.hasOwnProperty("toastText")) {
      state.toastText = payload.toastText;
    }
    if (payload.hasOwnProperty("position")) {
      state.toastPosition = payload.position;
    }
  },
  updateNavbarShow: function updateNavbarShow(state, payload) {
    state.navbarShow = payload.navbarShow;
  },
  updateSubsTabShow: function updateSubsTabShow(state, payload) {
    state.subs_tab_show = payload.subs_tab_show;
  },
  updateWebTabbarShow: function updateWebTabbarShow(state, payload) {
    state.web_tabbar_show = payload.web_tabbar_show;
  },
  updateWebNavbarShow: function updateWebNavbarShow(state, payload) {
    state.web_navbar_show = payload.web_navbar_show;
  },
  updateWebNavImgShow: function updateWebNavImgShow(state, payload) {
    state.web_navimg_show = payload.web_navimg_show;
  },
  updateCurrentUserData: function updateCurrentUserData(state, payload) {
    state.currentUserData = payload.currentUserData;
  },
  upadteServiceList: function upadteServiceList(state, payload) {
    state.service_list = payload;
  },
  updateAllPostCate: function updateAllPostCate(state, payload) {
    state.allPostCate = payload.allPostCate;
  },
  updateAllPostData: function updateAllPostData(state, payload) {
    state.allPostData = payload.allPostData;
  },
  updateAllPostSelectedId: function updateAllPostSelectedId(state, payload) {
    state.allPostSelectedId = payload.allPostSelectedId;
  },
  updateAccountShow: function updateAccountShow(state, payload) {
    state.web_account_show = payload.web_account_show;
  },
  updateAccountHistoryShow: function updateAccountHistoryShow(state, payload) {
    state.web_account_history_show = payload.web_account_history_show;
  },
  updateLoginShow: function updateLoginShow(state, payload) {
    state.web_login_show = payload.web_login_show;
  },
  updateAnonterCountShow: function updateAnonterCountShow(state, payload) {
    state.web_another_account_show = payload.web_another_account_show;
  },
  updateHistoryData: function updateHistoryData(state, payload) {
    state.web_history_data = payload.web_history_data;
    if (payload.id) {
      var usersData = localStorage.getItem("usersData");
      if (usersData) {
        var newArr = JSON.parse(usersData);

        for (var i in newArr) {
          if (newArr[i].userId == payload.id) {
            var dataJson = newArr[i];
            newArr.splice(i, 1);
            newArr.unshift(dataJson);
            break;
          }
        }
        localStorage.setItem("usersData", (0, _stringify2.default)(newArr));
        state.web_history_data = newArr;
      } else if (usersData == null || userData.lenght == 0) {
        state.web_history_data = [];
      }
    }
  },
  updateEditButtonShow: function updateEditButtonShow(state, payload) {
    state.web_edit_button_show = payload.web_edit_button_show;
  },
  updateAccountData: function updateAccountData(state, payload) {
    var usersData = localStorage.getItem("usersData");
    if (usersData) {
      var newArr = JSON.parse(usersData);
      for (var i in newArr) {
        if (newArr[i].userId == payload.id) {
          var dataJson = newArr[i];
          newArr.splice(i, 1);
          newArr.unshift(dataJson);
          break;
        }
      }
      state.web_account_data = newArr;
    } else if (usersData == null || userData.lenght == 0) {
      state.web_account_data = [];
    }
  },
  updateAddHomeShow: function updateAddHomeShow(state, payload) {
    if (payload.addHome == true) {
      var isSafari = navigator.vendor && navigator.vendor.indexOf("Apple") > -1 && navigator.userAgent.indexOf("Safari") > -1 && !navigator.userAgent.match("CriOS");

      if (navigator.userAgent.match(/(iPhone|iPod|iPad|iOS);?/i) && isSafari) {
        state.web_ios_addHome_show = true;
      } else if (navigator.userAgent.match(/Android/i)) {
        state.web_android_addHome_show = true;
      }
    } else {
      state.web_ios_addHome_show = false;
      state.web_android_addHome_show = false;
    }
  },
  updateAdsShow: function updateAdsShow(state, payload) {
    if (payload.adsShow) {

      if (sessionStorage.getItem("adsShow")) {
        if (sessionStorage.getItem("adsShow") == "on") {
          state.web_android_ads_show = true;
        } else {
          state.web_android_ads_show = false;
        }
      } else {
        state.web_android_ads_show = true;
      }
    } else {
      state.web_safari_ads_show = false;
      state.web_android_ads_show = false;
    }
  },
  updateLoginDetailShow: function updateLoginDetailShow(state, payload) {
    state.web_login_detail_show = payload.web_login_detail_show;
  },
  updateWebPaymentShow: function updateWebPaymentShow(state, payload) {
    state.web_payment_show = payload.web_payment_show;
  },
  updatePaymentResult: function updatePaymentResult(state, payload) {
    state.pay_result = payload.pay_result;
  },
  updatePaymentResultShowed: function updatePaymentResultShowed(state, payload) {
    state.payment_had_show = payload.payment_had_show;
  },
  updateFreePaymentShow: function updateFreePaymentShow(state, payload) {
    state.web_free_payment_show = payload.web_free_payment_show;
  },
  updateFreeListShow: function updateFreeListShow(state, payload) {
    state.freeListShow = payload.freeListShow;
  },
  updateMasterId: function updateMasterId(state, payload) {
    state.masterId = payload;
  }
};

/***/ }),
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/oval.be00fc4.svg";

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_add_to_homescreen_finger@3x.16c535d.png";

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_error@3x.ec6d36f.png";

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_guide_00@2x.e3fff89.png";

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_guide_01@3x.82ba793.png";

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_guide_02@3x.2f932fd.png";

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_instagram_icon@3x.9d6da7e.png";

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_logo@3x(5).bd4a2ee.png";

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_nav_account_arrow@3x(1).8ff61f9.png";

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_nav_collect@3x.3939c6f.png";

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_private_guide@3x.83a579e.png";

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_followers@3x.fb578dc.png";

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_followers_selceted@3x.35ba941.png";

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_like@3x.f1110f7.png";

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_like_selceted@3x.856081a.png";

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_more@3x.812b9d4.png";

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_more_selected@3x.079233a.png";

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_sub@3x.06903a6.png";

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/image_tabar_sub_selceted@3x.43ad489.png";

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(269),
  /* scopeId */
  "data-v-49ea0e9c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(266),
  /* scopeId */
  "data-v-1bb99712",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(270),
  /* scopeId */
  "data-v-72d6598a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(133),
  /* template */
  __webpack_require__(271),
  /* scopeId */
  "data-v-a6e9800a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(268),
  /* scopeId */
  "data-v-2e0d1d70",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(135),
  /* template */
  __webpack_require__(264),
  /* scopeId */
  "data-v-0f86772d",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(12)(
  /* script */
  __webpack_require__(136),
  /* template */
  __webpack_require__(267),
  /* scopeId */
  "data-v-1bd8d485",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.navType,
    attrs: {
      "id": "Nav"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.historyBack),
      expression: "!historyBack"
    }],
    staticClass: "back-icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.schemeUrl + '://'
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": __webpack_require__(67)
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyBack),
      expression: "historyBack"
    }],
    staticClass: "history-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": __webpack_require__(67)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('img', {
    staticClass: "user-img",
    attrs: {
      "src": _vm.userImg
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(this.titleName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coinShow),
      expression: "coinShow"
    }],
    staticClass: "userCoins"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(102),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userCoins))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectShow),
      expression: "collectShow"
    }],
    staticClass: "collect",
    on: {
      "click": _vm.addHome
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(247),
      "alt": ""
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('LoadingMid', {
    attrs: {
      "loading-show": _vm.midLoadingShow,
      "text": _vm.midLoadingText
    }
  }), _vm._v(" "), _c('Toast', {
    attrs: {
      "toast-show": _vm.toastShow,
      "text": _vm.toastText
    }
  }), _vm._v(" "), _c('AddToHome'), _vm._v(" "), _c('Login'), _vm._v(" "), _c('LoginDetail'), _vm._v(" "), _c('div', [_c('form', {
    attrs: {
      "action": _vm.paypalUrl,
      "method": "post",
      "target": "_top",
      "id": "post-form"
    }
  }, [_c('input', {
    attrs: {
      "type": "hidden",
      "name": "cmd",
      "value": "_s-xclick"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "hosted_button_id"
    },
    domProps: {
      "value": _vm.postData.button_id
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "custom"
    },
    domProps: {
      "value": _vm.postData.custom
    }
  })])]), _vm._v(" "), (_vm.web_navbar_show) ? _c('nav', [_c('WebTopBar', {
    attrs: {
      "title-name": _vm.navName,
      "user-img": _vm.webNavImg,
      "collect-show": _vm.collectShow,
      "img-show": _vm.navImgShow,
      "account-show": _vm.accountShow
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('main', [_c('router-view')], 1), _vm._v(" "), (_vm.webTabbarShow) ? _c('footer', [_c('div', {
    staticClass: "footer-inner"
  }, [_c('div', {
    staticClass: "tabbar-bottom",
    staticStyle: {
      "position": "fixed",
      "bottom": "0",
      "left": "0",
      "z-index": "10"
    }
  }, [_c('a', {
    class: {
      active: _vm.tabSeleced == 'follow'
    },
    on: {
      "click": _vm.followClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'follow'),
      expression: "tabSeleced != 'follow'"
    }],
    attrs: {
      "src": __webpack_require__(249)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'follow'),
      expression: "tabSeleced == 'follow'"
    }],
    attrs: {
      "src": __webpack_require__(250)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Followers")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'like'
    },
    on: {
      "click": _vm.likeClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'like'),
      expression: "tabSeleced != 'like'"
    }],
    attrs: {
      "src": __webpack_require__(251)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'like'),
      expression: "tabSeleced == 'like'"
    }],
    attrs: {
      "src": __webpack_require__(252)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Likes")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'subscription'
    },
    on: {
      "click": _vm.subscriptionClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'subscription'),
      expression: "tabSeleced != 'subscription'"
    }],
    attrs: {
      "src": __webpack_require__(255)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'subscription'),
      expression: "tabSeleced == 'subscription'"
    }],
    attrs: {
      "src": __webpack_require__(256)
    }
  }), _vm._v(" "), _c('span', [_vm._v("Subscriptions")]), _vm._v(" "), _c('i', [_vm._v("NEW")])]), _vm._v(" "), _c('a', {
    class: {
      active: _vm.tabSeleced == 'more'
    },
    on: {
      "click": _vm.moreClick
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced != 'more'),
      expression: "tabSeleced != 'more'"
    }],
    attrs: {
      "src": __webpack_require__(253)
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tabSeleced == 'more'),
      expression: "tabSeleced == 'more'"
    }],
    attrs: {
      "src": __webpack_require__(254)
    }
  }), _vm._v(" "), _c('span', [_vm._v("More")])])])])]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingShow),
      expression: "loadingShow"
    }],
    attrs: {
      "id": "loading-mid"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _vm._m(0)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "toast"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(238),
      "clss": "mid-icon"
    }
  })])
}]}

/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.navType,
    attrs: {
      "id": "Web_Nav"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.historyBack),
      expression: "historyBack"
    }],
    staticClass: "history-back",
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    staticClass: "back-img",
    attrs: {
      "src": __webpack_require__(67)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.accountShow),
      expression: "accountShow"
    }],
    staticClass: "account",
    attrs: {
      "disabled": ""
    },
    on: {
      "click": _vm.historyShow
    }
  }, [(!_vm.haveUserName) ? _c('input', {
    staticClass: "hidden-input",
    attrs: {
      "type": "text"
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "back-inner"
  }, [_c('a', {}, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.userImgShow),
      expression: "userImgShow"
    }],
    staticClass: "user-img",
    attrs: {
      "src": _vm.userImg
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.userImgShow),
      expression: "!userImgShow"
    }],
    staticClass: "userImg",
    attrs: {
      "src": __webpack_require__(106)
    }
  })])]), _vm._v(" "), _c('img', {
    staticClass: "down-img",
    attrs: {
      "src": __webpack_require__(246)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_c('h1', [_vm._v(_vm._s(this.titleName))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.coinShow),
      expression: "coinShow"
    }],
    staticClass: "userCoins"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(102),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.userCoins))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collectShow),
      expression: "collectShow"
    }],
    staticClass: "collect",
    on: {
      "click": _vm.addHome
    }
  })])
},staticRenderFns: []}

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "Toast"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    staticClass: "mask"
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toastShow),
      expression: "toastShow"
    }],
    staticClass: "content",
    class: {
      'top': _vm.position == 'top'
    }
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(240),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.text))])])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "AddToHome"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.iosAddShow),
      expression: "iosAddShow"
    }],
    staticClass: "ios"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('i', {
    on: {
      "click": _vm.hideAddHome
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(74),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.androidAddShow),
      expression: "androidAddShow"
    }],
    staticClass: "android"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticClass: "case",
    attrs: {
      "src": __webpack_require__(241)
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Do not want  to miss the discount?")]), _vm._v(" "), _c('div', {
    staticClass: "content-row"
  }, [_c('p', [_vm._v("Step 1: Tap the share button below")]), _c('img', {
    attrs: {
      "src": __webpack_require__(242),
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content-row"
  }, [_c('p', [_vm._v("Step 2: Choose “Add to Home Screen”")]), _c('img', {
    attrs: {
      "src": __webpack_require__(243),
      "alt": ""
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('img', {
    attrs: {
      "src": __webpack_require__(239),
      "alt": ""
    }
  })])
}]}

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.LoginShow) ? _c('div', {
    attrs: {
      "id": "Login"
    }
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.keydownLoading),
      expression: "keydownLoading"
    }],
    staticClass: "KeyEnterLoading"
  }, [_c('div', {
    staticClass: "mask-one"
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('h3', {
    staticClass: "clearfix"
  }, [_vm._m(1), _vm._v(" "), _c('a', {
    staticClass: "close-img",
    on: {
      "click": _vm.closeLogin
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(105),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "searchInputWrappe"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.searchInput),
      expression: "searchInput"
    }],
    ref: "input",
    class: {
      active: _vm.changing
    },
    attrs: {
      "type": "text",
      "name": "",
      "value": "",
      "placeholder": "Instagram username (not email, no password required)",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.searchInput)
    },
    on: {
      "keyup": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.keyEnterFun($event)
      }, _vm.onKeyUp],
      "focus": _vm.hideLogo,
      "blur": _vm.showLogo,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.searchInput = $event.target.value
      }
    }
  }), _vm._v(" "), _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clearShow),
      expression: "clearShow"
    }],
    on: {
      "click": _vm.emptyInput
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(110),
      "alt": ""
    }
  })])]), _vm._v(" "), _c('a', {
    staticClass: "confirm-button",
    class: {
      active: _vm.searchInput != '' && _vm.confirmOnoff == false
    },
    attrs: {
      "disabled": _vm.confirmOnoff
    },
    on: {
      "click": _vm.clickConfirm
    }
  }, [_c('span', [_vm._v("Get Started")])]), _vm._v(" "), _c('div', {
    staticClass: "please"
  }, [_c('p', [_c('span', [_vm._v("Please make sure you aren't using a private profile. ")]), _c('a', {
    on: {
      "click": _vm.detailShow
    }
  }, [_vm._v("See more >>")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.bottomLogo),
      expression: "bottomLogo"
    }],
    staticClass: "bottom-img"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(245),
      "alt": ""
    }
  })])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "LoadingMid"
  }, [_c('div', {
    staticClass: "sk-fading-circle"
  }, [_c('div', {
    staticClass: "sk-circle1 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle2 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle3 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle4 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle5 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle6 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle7 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle8 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle9 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle10 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle11 sk-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "sk-circle12 sk-circle"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "title-inner"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(244),
      "alt": ""
    }
  }), _c('i', [_vm._v("Enter your Instagram username")])])
}]}

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.detailShow) ? _c('div', {
    attrs: {
      "id": "more-detail"
    }
  }, [_c('div', {
    staticClass: "top"
  }, [_c('a', {
    on: {
      "click": _vm.goBack
    }
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(74),
      "alt": ""
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("Notice")])]), _vm._v(" "), _c('div', {
    staticClass: "title clearfix"
  }, [_c('img', {
    attrs: {
      "src": __webpack_require__(111),
      "alt": ""
    }
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.contentData.title))])]), _vm._v(" "), _vm._m(0)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bottom"
  }, [_c('p', [_vm._v("Switch Off the \"Private Account\" in the Settings of Instagram app.")]), _vm._v(" "), _c('img', {
    attrs: {
      "src": __webpack_require__(248),
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v("Your posts will receive likes and views only when your account is public. So you need to make sure you aren't using a private profile.")])])
}]}

/***/ })
]),[137]);


// WEBPACK FOOTER //
// static/js/app.fd874042a76ffa28ec41.js